import { IdentificationComponent } from './components/commonComponents/IdentificationComponent';

export class VariantAndDoorsForChecklist{
    isSelected:boolean;
    id:number;
    name:string;
    doors:DoorForChecklist[];
    hasCollissions:boolean;
}

export class DoorForChecklist extends IdentificationComponent{
    isSelected:boolean;
    isUpperDoor:boolean;
}